/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {

    "use strict";

    export class ReportsTollsController {

        constructor ( ) { }
    }

    getDealerwareWebContentModule().controller(
        'ReportsTollsController', ReportsTollsController
    );
}
